import { getAllLoanFeesQuery } from '@/shared/graphql/lp/lending';
import { useGqlQuery } from '@/shared/hooks/useGqlQuery';

export const useLpLoanFees = (variables: { loanIds: string[] }) => {
  const { data, isLoading } = useGqlQuery(getAllLoanFeesQuery, {
    context: { clientName: 'lpProcessor' },
    variables,
    refetchInterval: 6_000,
  });

  return {
    data: data?.allLoanFees?.edges.reduce((acc: Record<string, number>, { node }) => {
      const { loanId } = node;
      const feeUsd = parseFloat(node.totalAmountValueUsd);

      acc[loanId] = (acc[loanId] || 0) + feeUsd;
      return acc;
    }, {}),
    isLoading,
  };
};
